import React from "react";
import cn from 'classnames';
import { Dropdown } from "react-bootstrap";
import { ThreeDotMenu } from "components";
import { StageState } from "enums";
import { IStage } from "interfaces";
import { UpdatePageModel } from "../UpdatePageModel";
import { Link } from "react-router-dom";
import { getDefaultUpdateParams_stage, getUpdateResultsURL } from "pages/Reports/ReportsModel";

export interface IStageMenuProps {
    canEdit: boolean,
    className?: string,
    isNewStage: boolean,
    menuRef?: React.MutableRefObject<HTMLDivElement>,
    model: UpdatePageModel,
    stage: IStage,
    onDelete: () => void,
}

export function StageMenu({ canEdit, className, isNewStage, menuRef, model, stage, onDelete }: IStageMenuProps) {
    const update = model.update;
    const stageIndex = update.rollout.stages.findIndex(s => s.id === stage.id);
    const hasStarted = stage.state !== StageState.Scheduled;
    // Don't allow deleting the last stage
    const hasMoreThan1Stage = update.rollout.stages.length > 1;

    // Build a url to the stage results.
    const updateParams = getDefaultUpdateParams_stage(update.id, stageIndex, stage.state);
    const resultsURL = getUpdateResultsURL(updateParams);

    return <ThreeDotMenu ref={menuRef} className={cn('stageMenu', className)}>
        {!isNewStage && (
            <Link to={resultsURL} className="dropdown-item">
                {!hasStarted && 'View affected devices'}
                {hasStarted && 'View results'}
            </Link>
        )}
        {canEdit && (isNewStage || hasMoreThan1Stage) && <>
            {!isNewStage && <Dropdown.Divider />}
            <Dropdown.Item as="button" onClick={onDelete} className="dropdown-item-danger">
                Delete
            </Dropdown.Item>
        </>}
    </ThreeDotMenu>;
}